// Metatags da página. O servidor (enb-api/src/seo) já entrega o index.html com elas preenchidas;
// aqui só atualizamos as mesmas tags durante a navegação, seguindo as mesmas regras do servidor.

function setTag(selector, value) {
  const el = document.head.querySelector(selector)
  if (el) el.setAttribute(el.tagName === 'LINK' ? 'href' : 'content', value || '')
}

export function setMeta({ title, description, image, url } = {}) {
  if (title !== undefined) {
    document.title = title
    setTag('meta[property="og:title"]', title)
  }
  if (description !== undefined) {
    setTag('meta[name="description"]', description)
    setTag('meta[property="og:description"]', description)
  }
  if (image !== undefined) setTag('meta[property="og:image"]', image)
  if (url !== undefined) {
    setTag('meta[property="og:url"]', url)
    setTag('link[rel="canonical"]', url)
  }
}

// Remove HTML da descrição e limita ao tamanho usado pelos buscadores
function toDescription(texto) {
  let limpo = String(texto || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()
  return limpo.length > 160 ? limpo.substring(0, 157).trim() + '...' : limpo
}

export function defaultMeta(empresa) {
  return {
    title: empresa.metatitle || empresa.nome_empresa || 'enb',
    description: empresa.metadescription || '',
    image: empresa.logo ? `${window.location.origin}/og/logo` : '',
    url: window.location.origin + window.location.pathname
  }
}

export function produtoMeta(empresa, produto) {
  return {
    title: `${produto.name} | ${empresa.nome_empresa}`,
    description: toDescription(produto.descricao) || empresa.metadescription || '',
    image: produto.img && produto.img.length ? `${window.location.origin}/og/produto/${produto.id}` : undefined
  }
}

export function categoriaMeta(empresa, categoria) {
  return { title: `${categoria.name} | ${empresa.nome_empresa}` }
}

// Mixin: o componente define o computed `metaPage` (ou null) e ele é aplicado
// depois do router.afterEach do main.js, que volta tudo para o padrão da loja
export default {
  watch: {
    metaPage: { handler: 'applyMetaPage', immediate: true, flush: 'post' },
    $route: { handler: 'applyMetaPage', flush: 'post' }
  },
  methods: {
    applyMetaPage () {
      if (this.metaPage) setMeta(this.metaPage)
    }
  }
}
